import React from 'react';
import PropTypes from 'prop-types';

import Analytics from '@module/analytics';

import Icon from '@component/icon';
import AppBarHOC from '@component/info/appbar-hoc';

const openInAppEvent = () => {
  Analytics.pushDataLayerEvent({
    category: 'open in app banner',
    action: 'open in app',
  });

  Analytics.trackStructEvent({
    category: 'transfer',
    action: 'click_open_in_app',
    property: 'top_banner_download_page',
  });
};
const downloadAppEvent = () => {
  Analytics.pushDataLayerEvent({
    category: 'open in app banner',
    action: 'download app',
  });

  Analytics.trackStructEvent({
    category: 'transfer',
    action: 'click_download_the_app',
    property: 'top_banner_download_page',
  });
};

export const AppBar = ({
  appUri,
  downloadUri,
  title,
  description,
  openAppTitle,
  downloadAppTitle,
}) => {
  const openAppButtonClass = ['button', 'button--enabled'];

  const openAppButton = (
    <a
      onClick={openInAppEvent}
      className={openAppButtonClass.join(' ')}
      href={appUri}
    >
      {openAppTitle}{' '}
    </a>
  );
  const downloadAppButton = (
    <a
      onClick={downloadAppEvent}
      className="button button--enabled"
      href={downloadUri}
    >
      {downloadAppTitle}
    </a>
  );

  return (
    <div className="appbar">
      <div className="appbar__logo">
        <Icon type="Collect" />
      </div>

      <div className="appbar__text">
        <h4>{title}</h4>
        <p>{description}</p>
      </div>

      <div className="appbar__buttons">
        {openAppButton}
        {downloadAppButton}
      </div>
    </div>
  );
};

AppBar.propTypes = {
  onClose: PropTypes.func,
  appUri: PropTypes.string,
  downloadUri: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  openAppTitle: PropTypes.string,
  downloadAppTitle: PropTypes.string,
};

export default AppBarHOC(AppBar);
